/* eslint-disable react/prop-types */
import React from 'react';

import {Calendar} from 'react-date-range'
import {ptBR} from 'date-fns/locale'

import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

import {ContainerDate} from './styles'
import {addDays} from "date-fns";

export default function DatePicker({onChange, dates}) {

    const dateDefault = dates.startDate ?? new Date();

    return (
        <ContainerDate noDate={dates.startDate}>
            <Calendar
                date={dateDefault}
                onChange={onChange}
                showMonthAndYearPickers={false}
                moveRangeOnFirstSelection={false}
                showDateDisplay={false}
                locale={ptBR}
                monthDisplayFormat="LLLL"
                weekdayDisplayFormat="EEEEEE"
                minDate={addDays(new Date(), 3)}
                direction="horizontal"
            />
        </ContainerDate>
    );
}
